/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import {CardLoading} from '../loading/CardLoading'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'

type Props = {
  className: string
  uuid?: string
  identifier?: string
  contract_type?: string
  measurement?: string
  start_contract?: string
  expiration_contract?: string
  property?: {
    uuid?: string
    name: string
    id: number
    fields?: [
      {
        name: string
        id: number
      }
    ]
  }
  project?: {
    uuid?: string
    code: string
    description?: string
    id: number
  }
}

const CardSystemWidgetOneContract: React.FC<Props> = ({
  className,
  identifier,
  contract_type,
  measurement,
  start_contract,
  property,
  project,
}) => {
  const intl = useIntl()
  console.log('project', project)
  return (
    <div
      className={`card ${className} 
          border          
          border-gray-300                   
          `}
    >
      {/* begin::Body */}
      <div className='container-fluid  px-5 mb-3'>
        {identifier ? (
          <>
            {/* begin::Row */}
            <div className='row p-3'>
              {/* begin::Col */}

              <div className='col-xl-12 p-3 pb-0'>
                <p className='mt-0 mb-4 fs-3 fw-bold'>
                  {intl.formatMessage({id: 'CONTRACTS.TITLE_STEAP1'})}
                </p>
              </div>

              {/* Inicio coluna 01 */}
              <div className='col justify-content-center'>
                <div className='fw-semibold fs-8 pb-2 '>
                  {intl.formatMessage({id: 'PROPERTIES.TITLE'})}
                  <div className='text-primary'>
                    <Link to={'/editproperties/' + property?.uuid} title='Visualizar Propriedade'>
                      {property?.name}
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    </Link>
                  </div>
                </div>

                <div className='fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'CONTRACTS.TYPE'})}
                  <div className='text-primary'>
                    {contract_type === 'production' &&
                      intl.formatMessage({id: 'CONTRACTS.TYPE_PRODUCTION'})}
                    {contract_type === 'servitude' &&
                      intl.formatMessage({id: 'CONTRACTS.TYPE_SERVITUDE'})}
                    {contract_type === 'not_specified' &&
                      intl.formatMessage({id: 'CONTRACTS.NOT_SPECIFIED'})}
                  </div>
                </div>
              </div>
              {/* Final coluna 01 */}

              {/* Inicio coluna 02 */}
              <div className='col justify-content-center'>
                <div className='fw-semibold fs-8 pb-2 '>
                  {intl.formatMessage({id: 'PROJECT.PROJECT_TITLE'})}
                  <div className='text-primary'>
                    <Link to={'/projects'} title='Visualizar Projeto'>
                      {`${project?.code} - ${project?.description} `}
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-muted svg-icon p-1 text-primary'
                      />
                    </Link>
                  </div>
                </div>

                <div className='fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'CONTRACTS.MEASUREMENT'})}
                  <div className='text-primary'>
                    <div className='text-primary'>
                      {measurement === 'yearly' &&
                        intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY'})}
                      {measurement === 'monthly' &&
                        intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_MONTHLY'})}
                      {measurement === 'punctually' &&
                        intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_PUNCTUALLY'})}
                      {measurement === 'yearly_monthly' &&
                        intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY_MONTHLY'})}
                      {measurement === 'free' &&
                        intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_FREE'})}
                      {measurement === 'not_specified' &&
                        intl.formatMessage({id: 'CONTRACTS.NOT_SPECIFIED'})}
                    </div>
                  </div>
                </div>
              </div>
              {/* Final coluna 02 */}

              {/* Inicio coluna 03 */}
              <div className='col justify-content-center'>
                <div className='fw-semibold fs-8 pb-2 '>
                  {intl.formatMessage({id: 'CONTRACTS.IDENTIFIER'})}
                  <div className='text-primary'>{identifier}</div>
                </div>

                <div className='fw-semibold fs-8  '>
                  {intl.formatMessage({id: 'CONTRACTS.START_DATE'})}
                  <div className='text-primary'>{start_contract}</div>
                </div>
              </div>
              {/* Final coluna 03 */}
            </div>
          </>
        ) : (
          <CardLoading />
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetOneContract}
